import * as bookApi from '../../services/api/bookApi';
import * as bookService from '../../services/domain/bookService';
import { findLessonInBook } from '../../services/domain/annotationsService';

const booksCache = {};

export const loadGradebookBook = (classroomId, gradebookBook) => {
  const cacheKey = `${classroomId}:${gradebookBook.id}`;
  if (!booksCache[cacheKey]) {
    booksCache[cacheKey] = bookApi
      .getBook(classroomId, gradebookBook.id)
      .then(res => bookService.transformCmi5ToBook(res.data, gradebookBook.id))
      .catch(error => {
        delete booksCache[cacheKey];
        throw error;
      });
  }
  return booksCache[cacheKey];
};

export const openGradebookContent = ({
  book,
  lessonActivityId,
  questionActivityId,
  bookActions,
  accountActions,
  account,
  institution,
  classroom
}) => {
  const { lessonFound, unitFound } = findLessonInBook(book, lessonActivityId);
  if (!lessonFound || !unitFound) {
    return false;
  }

  accountActions.forceCheckAndRefreshToken(() => {
    if (bookService.isLinkActivity(lessonFound.format)) {
      bookActions.openLink(lessonFound.url);
    } else {
      bookActions.openResource({
        book,
        unit: unitFound,
        lesson: lessonFound,
        account,
        institution,
        classroom,
        questionActivityId
      });
    }
  });
  return true;
};
